import React, {FC} from 'react'
import {Form} from 'react-bootstrap'
import {NotificationType} from 'src/interfaces/SuperadminNews.interface'

export const NOTIFICATION_TYPES: {label: string; value: NotificationType}[] = [
  {label: 'Coming Soon', value: 'COMING_SOON'},
  {label: 'News & Announcements', value: 'NEWS_ANNOUNCEMENTS'},
]

export type NewsUpdateFormValues = {
  releaseDate: string
  heading: string
  description: string
  type: NotificationType
}

type Props = {
  values: NewsUpdateFormValues
  onChange: <K extends keyof NewsUpdateFormValues>(field: K, value: NewsUpdateFormValues[K]) => void
  onSubmit: (event: React.FormEvent) => void
  submitting?: boolean
  submitLabel?: string
  showActions?: boolean
  showCancel?: boolean
  onCancel?: () => void
  formId?: string
}

const NewsUpdateForm: FC<Props> = ({
  values,
  onChange,
  onSubmit,
  submitting = false,
  submitLabel = 'Publish Update',
  showActions = true,
  showCancel = false,
  onCancel,
  formId = 'news-update-form',
}) => {
  return (
    <Form id={formId} className='superadmin-news-form' onSubmit={onSubmit}>
      <div className='fv-row mb-7'>
        <Form.Label htmlFor={`${formId}-type`} className='required fs-6 fw-semibold mb-2'>
          Notification Type
        </Form.Label>
        <Form.Select
          id={`${formId}-type`}
          value={values.type}
          onChange={(e) => onChange('type', e.target.value as NotificationType)}
          required
        >
          {NOTIFICATION_TYPES.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      </div>

      <div className='fv-row mb-7'>
        <Form.Label htmlFor={`${formId}-release-date`} className='required fs-6 fw-semibold mb-2'>
          {values.type === 'COMING_SOON' ? 'Expected Timeline' : 'Date of Feature Released'}
        </Form.Label>
        <Form.Control
          id={`${formId}-release-date`}
          type='date'
          value={values.releaseDate}
          onChange={(e) => onChange('releaseDate', e.target.value)}
          required
        />
      </div>

      <div className='fv-row mb-7'>
        <Form.Label htmlFor={`${formId}-heading`} className='required fs-6 fw-semibold mb-2'>
          Feature Heading
        </Form.Label>
        <Form.Control
          id={`${formId}-heading`}
          type='text'
          placeholder='e.g., Introducing QuickBooks Integration'
          value={values.heading}
          onChange={(e) => onChange('heading', e.target.value)}
          required
        />
      </div>

      <div className='fv-row mb-0'>
        <Form.Label htmlFor={`${formId}-description`} className='required fs-6 fw-semibold mb-2'>
          Description
        </Form.Label>
        <Form.Control
          as='textarea'
          id={`${formId}-description`}
          rows={5}
          placeholder='Enter feature details, updates, or configuration guidelines here...'
          value={values.description}
          onChange={(e) => onChange('description', e.target.value)}
          required
        />
      </div>

      {showActions ? (
        <div className={`d-flex ${showCancel ? 'justify-content-end gap-3' : ''} mt-8`}>
          {showCancel ? (
            <button type='button' className='btn btn-sm btn-light fw-semibold' onClick={onCancel}>
              Cancel
            </button>
          ) : null}
          <button type='submit' className='btn btn-sm btn-primary fw-bold' disabled={submitting}>
            {submitting ? 'Publishing...' : submitLabel}
          </button>
        </div>
      ) : null}
    </Form>
  )
}

export default NewsUpdateForm
